import React, { ReactNode, useContext, useEffect, useState } from 'react';
import PrivateSidebar from '../../components/PrivateSidebar/PrivateSidebar';
import PrivateNavbar from '../../components/PrivateNavbar/PrivateNavbar';
// import './PrivateLayout.css';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { Spinner } from 'flowbite-react';
import getSidebarClass, * as styles from './privateLayout.styles'
import CustomModal from '../../components/Modal/CustomModal';
import CreatePinModal from '../../components/CreatePinModal/CreatePinModal';
import NotificationPopupModal from '../../components/NotificationPopupModal/NotificationPopupModal';
import showToast from '../../components/CustomToast/toastHelper';
import client from '../../api/client';
import OtpVerificationModal from '../../components/OtpVerificationModal/OtpVerificationModal';

interface PublicLayoutProps {
  children: ReactNode;
}

const PrivateLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [openPinModal,setOpenPinModal] = useState<boolean>(false)
  const [openOtpModal, setOpenOtpModal] = useState<boolean>(false)
  const [type, setType] = useState<string>('intro')
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const { userDetails, setUserDetails, fetchUser } = useContext(UserContext) ?? {}
  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  useEffect(() => {
    let token = sessionStorage.getItem("accessToken")
    if (!token) {
      navigate("/login");
    } else if (fetchUser) {
      fetchUser();
    }
  }, [ navigate])

  // useEffect(()=>{
  //   if(userDetails){
  //     console.log(userDetails);
      
  //     if(userDetails?.user?.pin == null && userDetails?.activeSubsidiary?.verificationStatus == "Active" ){
  //       setOpenPinModal(true)
  //     }
  //   }
  // },[userDetails])

  if (!userDetails) {
    return (
    <div className='flex justify-center items-center min-h-screen'>
      <Spinner size='xl' />
      </div>)
  }

 

  return (
    <div className="flex min-h-screen" >
      <div className={getSidebarClass(isSidebarOpen)}>
        <PrivateSidebar closeSidebar={toggleSidebar} />
      </div>
      <div className="flex-grow overflow-x-auto min-h-screen">
        <PrivateNavbar toggleSidebar={toggleSidebar} userDetails={userDetails} setUser={setUserDetails} />
        {children}
      </div>
      
    </div>
  );
};

export default PrivateLayout;
